/**
 * Format a cents value as currency, or return placeholder if commissions are hidden.
 * Use this instead of direct formatCurrency calls for commission amounts.
 */
export function formatCommissionValue(
  cents: number,
  hideCommissions: boolean,
  formatter?: (cents: number) => string
): string {
  if (hideCommissions) return '\u2014';
  return formatter
    ? formatter(cents)
    : `$${(cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2 })}`;
}

/**
 * GST basis note for every commission money surface.
 *
 * `commission_cents` is GST-EXCLUSIVE fleet-wide (gst_cents is 10% ON TOP), so
 * every surface that shows a commission-derived dollar figure carries this
 * note: the dashboard and office commission tiles (which sum
 * `COALESCE(gross_commission_cents, commission_cents)`), and the surfaces that
 * sum bare `commission_cents`: Monthly Table View, Commission Settings,
 * RCTI Cashflow (upfront, trail and deductions), Broker report, Broker Loan
 * Books, Clawbacks, Trail Book Valuation and the Discharge Watch-List.
 *
 * HISTORY. Until the My Mortgage Freedom ex-GST conversion, MyMF was the one
 * tenant whose `commission_cents` was GST-INCLUSIVE (its Finsure template
 * mapped the GST-inclusive 'Remitted/Net' column into the canonical
 * amountExGst field), so the note was deliberately limited to the dashboard and
 * office tiles. That exception ended with the conversion; see
 * docs/handovers/2026-10-05-MYMF-EX-GST-BASIS-HANDOVER.md (section 8 step G).
 *
 * NOT applied to loan amounts, balances, counts or Line of Trail (not
 * commission money), nor to RCTI aggregator charges or the RCTI grand total,
 * which include `raw_company_adjustments.amount_cents` whose GST basis has not
 * been verified.
 */
export const COMMISSION_GST_BASIS = 'ex GST';
